<div *ngIf="(showSpinner$ | async) && !showDraftsPopup" class="fade modal-backdrop show d-flex align-self-center justify-content-center">
  <div class="spinner">
    <div class="flex-column spinner">
      <div class="spinner__icon spinner__icon--large"></div>
    </div>
  </div>
</div>
